var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listCreateBtn },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listUpdateBtn },
                        },
                        [_vm._v("修改")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDetailsBtn },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.initOutOrd },
                        },
                        [_vm._v("确认")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.out },
                        },
                        [_vm._v("配货")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.showPayment },
                        },
                        [_vm._v("支付")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.printOpen },
                            },
                            [_vm._v("打印")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_id",
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["id"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "id", $$v)
                                  },
                                  expression: "data.head['id']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_code",
                                attrs: {
                                  code: "code",
                                  name: "编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["code"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "code", $$v)
                                  },
                                  expression: "data.head['code']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-datetime", {
                                ref: "input_businessTime",
                                attrs: {
                                  code: "businessTime",
                                  name: "业务时间",
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["businessTime"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "businessTime", $$v)
                                  },
                                  expression: "data.head['businessTime']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_userId",
                                attrs: {
                                  code: "userId",
                                  name: "用户ID",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["userId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "userId", $$v)
                                  },
                                  expression: "data.head['userId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_userCode",
                                attrs: {
                                  url: "base/user/user/user/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "userCode",
                                  name: "用户编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["userCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "userCode", $$v)
                                  },
                                  expression: "data.head['userCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_userName",
                                attrs: {
                                  code: "userName",
                                  name: "用户名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["userName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "userName", $$v)
                                  },
                                  expression: "data.head['userName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_positionId",
                                attrs: {
                                  code: "positionId",
                                  name: "药库ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionId", $$v)
                                  },
                                  expression: "data.head['positionId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_positionCode",
                                attrs: {
                                  code: "positionCode",
                                  name: "药库编码",
                                  url: "clinic/inventory/inventory/position/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: { storeId: _vm.storeId },
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["positionCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionCode", $$v)
                                  },
                                  expression: "data.head['positionCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_positionName",
                                attrs: {
                                  code: "positionName",
                                  name: "药库名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionName", $$v)
                                  },
                                  expression: "data.head['positionName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_positionPositionSign",
                                attrs: {
                                  code: "positionPositionSign",
                                  name: "位置标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.positionSign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionPositionSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "positionPositionSign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['positionPositionSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_positionClassifySign",
                                attrs: {
                                  code: "positionClassifySign",
                                  name: "分类标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.classifySign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionClassifySign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "positionClassifySign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['positionClassifySign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_executeSign",
                                attrs: {
                                  code: "executeSign",
                                  name: "执行标识",
                                  "default-value": "1",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.executeSign),
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["executeSign"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "executeSign", $$v)
                                  },
                                  expression: "data.head['executeSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_saleAmount",
                                attrs: {
                                  code: "saleAmount",
                                  name: "销售金额",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["saleAmount"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "saleAmount", $$v)
                                  },
                                  expression: "data.head['saleAmount']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode == "info"
                ? _c(
                    "el-tabs",
                    {
                      ref: "ik-info-body",
                      staticClass: "retail-ord-tabs-info",
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: _vm.bodyMap[0].key,
                          staticStyle: { height: "100%" },
                          attrs: {
                            name: _vm.bodyMap[0].key,
                            label: _vm.bodyMap[0].name,
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                                {
                                  name: "horizontal-scroll",
                                  rawName: "v-horizontal-scroll",
                                  value: "always",
                                  expression: "'always'",
                                },
                              ],
                              ref: "tablesub",
                              staticClass: "ik-list-table",
                              attrs: {
                                data: _vm.data.body[_vm.bodyMap[0].key],
                                "element-loading-text": "加载中...",
                                stripe: true,
                                border: true,
                                fit: true,
                                height: "100%",
                                "header-row-class-name":
                                  "ik-list-table-header-row",
                                "header-cell-class-name":
                                  "ik-list-table-header-cell",
                                "row-class-name": "ik-list-table-body-row",
                                "cell-class-name": "ik-list-table-body-cell",
                                "highlight-current-row": true,
                              },
                            },
                            [
                              _vm.mode !== "details"
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "pluss",
                                      label: "操作",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        padding: "0px 12px",
                                                      },
                                                    },
                                                    [_vm._v("操作")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "26px",
                                                        height: "26px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: {
                                                        circle: "",
                                                        title: "添加首行",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addRow(
                                                            _vm.activeTab,
                                                            -1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.addRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2415510340
                                    ),
                                  })
                                : _vm._e(),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  edit: _vm.mode !== "details",
                                },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "materielId",
                                  name: "物料ID",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "materielCode",
                                  name: "药品编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "materielName",
                                  name: "药品名称",
                                  url: "clinic/inventory/inventory/inventory/find/findBatchInventoryPagination",
                                  "filed-list": [
                                    { code: "materielCode", name: "编码" },
                                    { code: "materielIotCode", name: "条码" },
                                    { code: "materielName", name: "名称" },
                                    { code: "batchCode", name: "批次" },
                                    {
                                      code: "qualitySign",
                                      name: "品质",
                                      type: "select",
                                      options: _vm.toJson(
                                        _vm.jsonStr.qualitySign
                                      ),
                                    },
                                    {
                                      code: "manufacturerName",
                                      name: "生产商",
                                    },
                                    { code: "supplierName", name: "供应商" },
                                    {
                                      code: "number",
                                      name: "余量",
                                      type: "number",
                                    },
                                    {
                                      code: "costPrice",
                                      name: "成本单价",
                                      type: "number",
                                    },
                                  ],
                                  "search-key": "materielName",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    positionCode: _vm.data.head["positionCode"],
                                    materielTypeSign: "5",
                                  },
                                  "popup-width": "100%",
                                  edit: _vm.mode !== "details",
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "iotCode",
                                  name: "条码",
                                  url: "clinic/inventory/inventory/inventory/find/findBatchInventoryPagination",
                                  "filed-list": [
                                    { code: "materielCode", name: "编码" },
                                    { code: "materielIotCode", name: "条码" },
                                    { code: "materielName", name: "名称" },
                                    { code: "batchCode", name: "批次" },
                                    {
                                      code: "qualitySign",
                                      name: "品质",
                                      type: "select",
                                      options: _vm.toJson(
                                        _vm.jsonStr.qualitySign
                                      ),
                                    },
                                    {
                                      code: "manufacturerName",
                                      name: "生产商",
                                    },
                                    { code: "supplierName", name: "供应商" },
                                    {
                                      code: "number",
                                      name: "余量",
                                      type: "number",
                                    },
                                    {
                                      code: "costPrice",
                                      name: "成本单价",
                                      type: "number",
                                    },
                                  ],
                                  "search-key": "materielIotCode",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    positionCode: _vm.data.head["positionCode"],
                                  },
                                  "popup-width": "100%",
                                  edit: _vm.mode !== "details",
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "medSpecId",
                                  name: "药品规格ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medSpecCode",
                                  name: "药品规格编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medSpecName",
                                  name: "药品规格名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "medDosageId",
                                  name: "药品剂型ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medDosageCode",
                                  name: "药品剂型编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medDosageName",
                                  name: "药品剂型名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-select", {
                                attrs: {
                                  code: "qualitySign",
                                  name: "品质标识",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.qualitySign),
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "sellingNum",
                                  name: "销售数量",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "costPrice",
                                  name: "成本单价",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "costAmount",
                                  name: "成本金额",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "salePrice",
                                  name: "销售单价",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "saleAmount",
                                  name: "销售金额",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "medUomId",
                                  name: "药品单位ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medUomCode",
                                  name: "药品单位编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medUomName",
                                  name: "药品单位名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medAdvice",
                                  name: "医嘱",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "dayNum",
                                  name: "用药天数",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "dayFreq",
                                  name: "每日次数",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "freqNum",
                                  name: "每次剂量",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "meaUomId",
                                  name: "计量单位ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "meaUomCode",
                                  name: "计量单位编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "meaUomName",
                                  name: "计量单位名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_code",
                                            attrs: {
                                              code: "code",
                                              name: "编码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["code"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['code']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_executeSign",
                                            attrs: {
                                              code: "executeSign",
                                              name: "执行标识",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.executeSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["executeSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "executeSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['executeSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-id", {
                                            ref: "input_positionId",
                                            attrs: {
                                              code: "positionId",
                                              name: "药库ID",
                                              "default-value": 0,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["positionId"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "positionId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['positionId']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_positionCode",
                                            attrs: {
                                              code: "positionCode",
                                              name: "药库编码",
                                              url: "clinic/inventory/inventory/position/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {
                                                storeId: _vm.storeId,
                                              },
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["positionCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "positionCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['positionCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_positionName",
                                            attrs: {
                                              code: "positionName",
                                              name: "药库名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["positionName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "positionName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['positionName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-id", {
                        attrs: { code: "id", name: "ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "code", name: "编码", edit: false },
                      }),
                      _c("ik-column-datetime", {
                        attrs: {
                          code: "businessTime",
                          name: "业务时间",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: { code: "userId", name: "用户ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "userCode",
                          name: "用户编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "userName",
                          name: "用户名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: { code: "storeId", name: "门店ID", edit: false },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "positionId",
                          name: "药库ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "positionCode",
                          name: "药库编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "positionName",
                          name: "药库名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "executeSign",
                          name: "执行标识",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.executeSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "saleAmount",
                          name: "销售金额",
                          edit: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "支付结算",
            visible: _vm.dialogVisible,
            width: "500px",
            top: "16vh",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%" }, attrs: { id: "phy" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "ik-info-head",
                  attrs: {
                    inline: true,
                    "label-width": "70px",
                    disabled: false,
                  },
                  model: {
                    value: _vm.activeRow,
                    callback: function ($$v) {
                      _vm.activeRow = $$v
                    },
                    expression: "activeRow",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("ik-form-text", {
                            ref: "input_name",
                            attrs: {
                              code: "name",
                              name: "单号",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 20,
                              disabled: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.activeRow["code"],
                              callback: function ($$v) {
                                _vm.$set(_vm.activeRow, "code", $$v)
                              },
                              expression: "activeRow['code']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("ik-form-number", {
                            ref: "input_saleAmount",
                            attrs: {
                              code: "saleAmount",
                              name: "总价",
                              "default-value": 0,
                              disabled: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.activeRow["saleAmount"],
                              callback: function ($$v) {
                                _vm.$set(_vm.activeRow, "saleAmount", $$v)
                              },
                              expression: "activeRow['saleAmount']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("ik-form-number", {
                            ref: "input_discountAmount",
                            attrs: {
                              code: "discountAmount",
                              name: "优惠",
                              "default-value": 0,
                              disabled: false,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.activeRow["discountAmount"],
                              callback: function ($$v) {
                                _vm.$set(_vm.activeRow, "discountAmount", $$v)
                              },
                              expression: "activeRow['discountAmount']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("ik-form-number", {
                            ref: "input_paymentAmount",
                            attrs: {
                              code: "paymentAmount",
                              name: "实际支付",
                              disabled: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.activeRow["paymentAmount"],
                              callback: function ($$v) {
                                _vm.$set(_vm.activeRow, "paymentAmount", $$v)
                              },
                              expression: "activeRow['paymentAmount']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "flex", margin: "10px 0" },
                          },
                          [
                            _c("div", {
                              staticStyle: {
                                "border-left": "5px solid rgb(22, 93, 255)",
                                padding: "0 0 10px 10px",
                                "margin-left": "10px",
                              },
                            }),
                            _c("div", [_vm._v(" 支付方式 ")]),
                          ]
                        ),
                        _c("div", { staticClass: "phyClass" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon cursor-pointer flex flex-col align-center",
                              staticStyle: {
                                margin: "0 10px",
                                background: "#fff",
                                width: "80px",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pay("aliPay")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "icon-img",
                                attrs: {
                                  src: require("@/assets/list/aliPay.png"),
                                  alt: "",
                                },
                              }),
                              _c("span", { staticClass: "label" }, [
                                _vm._v("支付宝"),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon cursor-pointer flex flex-col align-center",
                              staticStyle: {
                                margin: "0 10px",
                                background: "#fff",
                                width: "80px",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pay("wechat")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "icon-img",
                                attrs: {
                                  src: require("@/assets/list/wechat.png"),
                                  alt: "",
                                },
                              }),
                              _c("span", { staticClass: "label" }, [
                                _vm._v("微信"),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon cursor-pointer flex flex-col align-center",
                              staticStyle: {
                                margin: "0 10px",
                                background: "#fff",
                                width: "80px",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pay("offline")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "icon-img",
                                attrs: {
                                  src: require("@/assets/list/offline.png"),
                                  alt: "",
                                },
                              }),
                              _c("span", { staticClass: "label" }, [
                                _vm._v("线下"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "479px",
            "destroy-on-close": true,
            "show-close": false,
            modal: false,
            "custom-class": "qrcode-con",
            visible: _vm.qrcodeVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrcodeVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "flex flex-col align-center qrcode" }, [
            _c(
              "div",
              { staticClass: "flex flex-row align-center pay-header" },
              [
                _vm.payWay === "aliPay"
                  ? _c("img", {
                      staticClass: "icon-img",
                      staticStyle: { "margin-top": "80px" },
                      attrs: {
                        src: require("@/assets/list/aliPay.png"),
                        alt: "",
                      },
                    })
                  : _vm._e(),
                _vm.payWay === "wechat"
                  ? _c("img", {
                      staticClass: "icon-img",
                      staticStyle: { "margin-top": "80px" },
                      attrs: {
                        src: require("@/assets/list/wechat.png"),
                        alt: "",
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "tip" }, [
                  _vm._v(
                    "请使用" +
                      _vm._s(_vm.payWay == "wechat" ? "微信" : "支付宝") +
                      "扫码支付"
                  ),
                ]),
              ]
            ),
            _c("div", { staticStyle: { "margin-top": "120px" } }, [
              _c("div", { ref: "qrcode" }),
            ]),
          ]),
        ]
      ),
      _c("RetailOrdP", { ref: "RetailOrdRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }